import React from 'react';

// NOTE: v1 placeholder artwork lifted from the seasonal_accessories_final.html
// mock. Composition + visibility tier are correct (medium-stronger —
// clearly seasonal, Turbo still recognisable), but the linework
// should be replaced with polished designer SVGs before any
// significant push of seasonal accessories.
//
// Renders inside Turbo's existing 200x200 viewBox so it scales with
// him at every size (44px sidebar → 200px 404 page).
export default function ChristmasAccessory() {
  return (
    <g aria-hidden="true">
      {/* Santa hat — droopy cone with floppy tip */}
      <path d="M72,96 Q80,55 115,42 Q140,38 142,48 Q140,55 130,60 Q138,70 130,80 Q140,85 128,96 Z" fill="#E0290A" />
      <path d="M78,90 Q85,68 105,55" stroke="#a51f08" strokeWidth="1.5" fill="none" opacity="0.6" />
      {/* White fluffy brim along the bottom */}
      <ellipse cx="100" cy="98" rx="32" ry="6" fill="#F9FCF1" />
      <circle cx="76" cy="98" r="5" fill="#F9FCF1" />
      <circle cx="86" cy="100" r="5" fill="#F9FCF1" />
      <circle cx="98" cy="100" r="5" fill="#F9FCF1" />
      <circle cx="110" cy="100" r="5" fill="#F9FCF1" />
      <circle cx="122" cy="98" r="5" fill="#F9FCF1" />
      {/* Pompom at the tip */}
      <circle cx="142" cy="48" r="11" fill="#F9FCF1" />
      <circle cx="138" cy="44" r="3" fill="#F9FCF1" />
      <circle cx="146" cy="44" r="3" fill="#F9FCF1" />
      <circle cx="146" cy="52" r="3" fill="#F9FCF1" />
      <circle cx="138" cy="52" r="3" fill="#F9FCF1" />
      {/* Snowflakes scattered around */}
      <g stroke="#F9FCF1" strokeWidth="1.2" strokeLinecap="round" fill="none">
        <g transform="translate(30 70)">
          <line x1="0" y1="-7" x2="0" y2="7" />
          <line x1="-7" y1="0" x2="7" y2="0" />
          <line x1="-5" y1="-5" x2="5" y2="5" />
          <line x1="-5" y1="5" x2="5" y2="-5" />
        </g>
        <g transform="translate(40 130)">
          <line x1="0" y1="-5" x2="0" y2="5" />
          <line x1="-5" y1="0" x2="5" y2="0" />
          <line x1="-3.5" y1="-3.5" x2="3.5" y2="3.5" />
          <line x1="-3.5" y1="3.5" x2="3.5" y2="-3.5" />
        </g>
        <g transform="translate(170 110)">
          <line x1="0" y1="-5" x2="0" y2="5" />
          <line x1="-5" y1="0" x2="5" y2="0" />
          <line x1="-3.5" y1="-3.5" x2="3.5" y2="3.5" />
          <line x1="-3.5" y1="3.5" x2="3.5" y2="-3.5" />
        </g>
      </g>
    </g>
  );
}
